export interface IUserServer {
    "id": number,
    "userId": number,
    "subscriptionEndDate": Date,
    "subscriptionType": string,
    "deviceLimit"?: DeviceLimit | null,
    /** Уменьшенный лимит устройств, выбранный пользователем — ждёт следующего продления подписки. */
    "pendingDeviceLimit"?: DeviceLimit | null,
    "accessData": string,
    "isEnabled": boolean
}

export interface IOrder {
    "id": number,
    "payId": string,
    "userId": number,
    "orderType": SUBSCRIPTION_TYPE,
    "deviceLimit"?: DeviceLimit | null,
    "paymentMethod": string,
    "createdAt": string,
    "amount": number
}

export interface IBusiness {
    "id": number;
    "name": string;
}

export interface  IUserDetails {
    "id": number;
    "telegramId": number | null;
    "createdAt": string;
    "userServer": IUserServer | null;
    "orders": IOrder[];
    "username"?: string;
    "business"?: IBusiness;
}

export enum SUBSCRIPTION_TYPE {
  TEST = 'test',
  M1 = 'm1',
  M3 = 'm3',
  M6 = 'm6',
  M12 = 'm12'
}

export const DAY_BY_SUBSCRIPTION_TYPE: Record<SUBSCRIPTION_TYPE, number> = {
  [SUBSCRIPTION_TYPE.TEST]: 3,
  [SUBSCRIPTION_TYPE.M1]: 30,
  [SUBSCRIPTION_TYPE.M3]: 90,
  [SUBSCRIPTION_TYPE.M6]: 180,
  [SUBSCRIPTION_TYPE.M12]: 365
};

export const SUBSCRIPTION_TYPE_NAME: Record<SUBSCRIPTION_TYPE, string> = {
  [SUBSCRIPTION_TYPE.TEST]: '3 дня',
  [SUBSCRIPTION_TYPE.M1]: '1 месяц',
  [SUBSCRIPTION_TYPE.M3]: '3 месяца',
  [SUBSCRIPTION_TYPE.M6]: '6 месяцев',
  [SUBSCRIPTION_TYPE.M12]: '12 месяцев'
};

/** Сколько месяцев в тарифе — используется для расчёта цены за месяц и скидки. */
export const MONTHS_BY_SUBSCRIPTION_TYPE: Record<SUBSCRIPTION_TYPE, number> = {
  [SUBSCRIPTION_TYPE.TEST]: 0,
  [SUBSCRIPTION_TYPE.M1]: 1,
  [SUBSCRIPTION_TYPE.M3]: 3,
  [SUBSCRIPTION_TYPE.M6]: 6,
  [SUBSCRIPTION_TYPE.M12]: 12
};

export type PaymentMethod = 'card' | 'sbp';

/** Тариф по количеству устройств в одной подписке. */
export type DeviceLimit = 3 | 5 | 10;
export const DEVICE_LIMITS: DeviceLimit[] = [3, 5, 10];
export const DEFAULT_DEVICE_LIMIT: DeviceLimit = 3;